import { render, staticRenderFns } from "./index.vue?vue&type=template&id=73e7484e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=73e7484e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e7484e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73e7484e')) {
      api.createRecord('73e7484e', component.options)
    } else {
      api.reload('73e7484e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=73e7484e&scoped=true&", function () {
      api.rerender('73e7484e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/channelDraw/index.vue"
export default component.exports